import { useGetAmendmentByIdQueryV2 } from '@xemplo/amendment-query';
import { Button, ButtonSize, ButtonType } from '@xemplo/button';
import { PAYRUN_COMPONENTS } from '@xemplo/gp-constants';
import { PayrunResubmitAmendment } from '@xemplo/payrun-resubmit-amendment';
import { RoleRenderer } from '@xemplo/role-renderer';
import { AuthorisationModule } from '@xemplo/role-types';

import { amendmentDetailsModalTestIds } from '../../../amendment-details-modal';
import * as S from '../../amendment-details-modal-styles';

import { getEditButtonType } from './edit-button/edit-button.helper';
import { RemoveAmendmentButton } from './remove-amendment-button/remove-amendment-button';

type FooterProps = {
  amendmentId: string;
  onClose?: () => void;
  onEdit?: () => void;
};

export const AmendmentDetailModalFooter = ({
  amendmentId,
  onClose,
  onEdit,
}: FooterProps) => {
  const { data: amendment } = useGetAmendmentByIdQueryV2({ id: amendmentId });
  if (!amendment) return null;
  const editButtonType = getEditButtonType(amendment);

  return (
    <S.FooterWrapper data-testid={amendmentDetailsModalTestIds.footer}>
      <RemoveAmendmentButton amendmentId={amendmentId} onSuccess={onClose} />
      <PayrunResubmitAmendment onSuccess={onClose} amendmentId={amendmentId} />
      {editButtonType && onEdit && (
        <RoleRenderer
          module={AuthorisationModule.payrun}
          component={PAYRUN_COMPONENTS.AMENDMENT_EDIT}
        >
          <Button
            ariaLabel="Edit Amendment"
            type={ButtonType.Secondary}
            size={ButtonSize.Medium}
            onClick={onEdit}
          >
            Edit
          </Button>
        </RoleRenderer>
      )}
    </S.FooterWrapper>
  );
};
